import axios from "axios";

export default function FulfillmentShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/fulfillment/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
